/**
 * SDR · Campos tab — API client (OpenSpec #5).
 *
 * GET/PUT /api/ia/proposal-fields-config. Reusa o axios configurado.
 */
import axios from 'axios';
import { apiService } from './api';
import { ProposalField, ProposalFieldsConfig } from '../types';

interface AxiosLike {
  get<T>(url: string): Promise<{ data: T }>;
  put<T>(url: string, body: unknown): Promise<{ data: T }>;
}

function getClient(): AxiosLike {
  const anySvc = apiService as unknown as { api: AxiosLike };
  return anySvc.api;
}

export interface PutProposalFieldsError extends Error {
  field?: string;
  reason?: string;
  status?: number;
}

export async function getProposalFieldsConfig(): Promise<ProposalFieldsConfig> {
  const res = await getClient().get<ProposalFieldsConfig>('/ia/proposal-fields-config');
  return res.data;
}

export interface PutProposalFieldsInput {
  objective: string;
  fields: ProposalField[];
  rules: string[];
  forbidden: string[];
  completion: string;
}

export async function putProposalFieldsConfig(
  payload: PutProposalFieldsInput,
): Promise<ProposalFieldsConfig> {
  try {
    const res = await getClient().put<ProposalFieldsConfig>('/ia/proposal-fields-config', payload);
    return res.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const data = err.response?.data || {};
      const out = new Error(
        data.reason || data.message || 'Erro ao salvar configuração de campos',
      ) as PutProposalFieldsError;
      out.field = data.field;
      out.reason = data.reason;
      out.status = err.response?.status;
      throw out;
    }
    throw err;
  }
}
